// MessageContext.tsx
import { createContext } from 'react';
import MessageContextType from './MessageContextType';

// Define and export the context
const MessageContext = createContext<MessageContextType | undefined>(undefined);
export default MessageContext;
